
import { useEffect } from 'react';
import './App.css';
import Main from './Main'

function App() {

    useEffect(() => {
      window.location.href = "https://personalassessmenttest.com/";
      
    }, []);

  return (
    <div >
      {/* <Main/> */}
    </div>
  );
}

export default App;
